// src/components/PinisiKata/PinisiKataGame.js
import React, { useReducer } from 'react';
import { questionsDatabase } from '../../gameLogics/pinisiKataData';
import Footer from '../Footer';

// Impor semua komponen layar yang akan diatur oleh game ini
import PinisiStartScreen from './PinisiStartScreen';
import PinisiLevelScreen from './PinisiLevelScreen';
import PinisiGameplayScreen from './PinisiGameplayScreen';
// (Kita akan membuat placeholder untuk dua layar terakhir ini nanti)
import PinisiBreakScreen from './PinisiBreakScreen';
import PinisiWinnerScreen from './PinisiWinnerScreen';

import styles from './PinisiKata.module.css';

// --- Aksi yang Mungkin Terjadi dalam Game ---
// Mendefinisikannya sebagai konstanta mencegah kesalahan ketik.
export const ACTIONS = {
    START_GAME: 'start-game',
    SELECT_LEVEL: 'select-level',
    SUBMIT_ANSWER: 'submit-answer',
    NEXT_QUESTION: 'next-question',
    CONTINUE_TO_NEXT_LEVEL: 'continue-to-next-level',
    RESTART_GAME: 'restart-game',
    GO_TO_SCREEN: 'go-to-screen',
};

// --- Aturan & Konfigurasi Game ---
const POINTS_CORRECT = 125;
const POINTS_INCORRECT = 50;
const MAX_LEVELS = 3;

// --- State Awal Permainan ---
const initialState = {
    screen: 'start', // 'start', 'level', 'game', 'break', 'winner'
    level: 1,
    questionIndex: 0,
    player1Score: 0,
    player2Score: 0,
};

// --- Reducer: Otak dari Semua Logika Game ---
function reducer(state, action) {
    switch (action.type) {
        case ACTIONS.GO_TO_SCREEN:
            return { ...state, screen: action.payload.screen };

        case ACTIONS.START_GAME:
            return { ...state, screen: 'level' };

        case ACTIONS.SELECT_LEVEL:
            return {
                // Reset semua state permainan saat level baru dimulai
                ...initialState,
                screen: 'game',
                level: action.payload.level,
            };

        case ACTIONS.SUBMIT_ANSWER: {
            const { player, isCorrect } = action.payload;
            
            if (isCorrect) {
                if (player === 1) {
                    return { ...state, player1Score: state.player1Score + POINTS_CORRECT };
                } else {
                    return { ...state, player2Score: state.player2Score + POINTS_CORRECT };
                }
            } else { // Jika salah
                if (player === 1) {
                    return { ...state, player1Score: Math.max(0, state.player1Score - POINTS_INCORRECT) };
                } else {
                    return { ...state, player2Score: Math.max(0, state.player2Score - POINTS_INCORRECT) };
                }
            }
        }

        case ACTIONS.NEXT_QUESTION: {
            const nextIndex = state.questionIndex + 1;
            const totalQuestions = questionsDatabase[`level${state.level}`].length;

            if (nextIndex >= totalQuestions) {
                // Jika soal di level ini habis
                if (state.level >= MAX_LEVELS) {
                    // Jika ini level terakhir, langsung ke layar pemenang
                    return { ...state, screen: 'winner' };
                } else {
                    // Jika tidak, tampilkan layar jeda antar level
                    return { ...state, screen: 'break' };
                }
            }
            // Jika masih ada soal, lanjutkan ke soal berikutnya
            return { ...state, questionIndex: nextIndex };
        }
        
        case ACTIONS.CONTINUE_TO_NEXT_LEVEL:
            return {
                ...state,
                screen: 'game',
                level: state.level + 1,
                questionIndex: 0, // Mulai dari soal pertama di level baru
            };
        
        case ACTIONS.RESTART_GAME:
            return { ...initialState, screen: 'start' }; // Kembali ke state awal sepenuhnya

        default:
            return state;
    }
}

/**
 * Komponen PinisiKataGame adalah orkestrator utama.
 * Ia tidak merender UI secara langsung, tetapi memilih komponen layar mana
 * yang akan dirender berdasarkan state yang dikelola oleh useReducer.
 * @param {object} props
 * @param {function} props.onGoHome - Fungsi untuk kembali ke menu pemilihan game utama.
 */
function PinisiKataGame({ onGoHome }) {
    const [state, dispatch] = useReducer(reducer, initialState);

    const renderCurrentScreen = () => {
        switch (state.screen) {
            case 'level':
                return <PinisiLevelScreen dispatch={dispatch} />;
            
            case 'game':
                return <PinisiGameplayScreen state={state} dispatch={dispatch} />;

            case 'break':
                // Gunakan komponen baru
                return <PinisiBreakScreen state={state} dispatch={dispatch} />;

            case 'winner':
                // Gunakan komponen baru
                return <PinisiWinnerScreen state={state} dispatch={dispatch} />;

            case 'start':
            default:
                return <PinisiStartScreen dispatch={dispatch} onGoHome={onGoHome} />;
        }
    };

    return (
        <div className={styles.gameContainer}>
            {renderCurrentScreen()}
            {/* Tambahkan Footer di sini (bisa dengan darkTheme jika perlu) */}
            <Footer darkTheme={state.screen === 'start'} />
        </div>
    );
}

export default PinisiKataGame;